module.exports = __webpack_public_path__ + "img/sv108on.b179947c.svg";